export default "__VITE_ASSET__DGdv3W5l__"